<div class="container">
  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  } @else {
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item [aboutCardId]="141"></ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    <div class="d-flex flex-wrap column-gap-4">
      <div class="dashboard-widget">
        <ziro-migrations-donut-chart
          data-automation="migration-status-chart"
          [isRefreshing]="isReportDataRefreshing()"
          [isError]="isReportWidgetError"
          [data]="migrationStatusData"
          [label]="'tkey;migrations.number_report.dashboard.migration_status.label'"
          [labelTooltip]="'tkey;migrations.ring_central.number_report.dashboard.migration_status.label.tooltip'"
          [colorScheme]="colorScheme"
          [customColors]="migrationStatusCustomColors"
          [segmentTooltipKeyword]="'tkey;migrations.number_report.dashboard.numbers.label'"
          [totalSubtext]="'tkey;migrations.number_report.dashboard.total_numbers.label'"
          [legendCountLabelSingular]="'tkey;migrations.number_report.dashboard.numbers.label.singular'"
          [legendCountLabelPlural]="'tkey;migrations.number_report.dashboard.numbers.label.plural'"
          (dataClick)="onNumbersReportFilter($event, 'migrationStatus')"
          (errorButtonClick)="onRefreshClick()"
        ></ziro-migrations-donut-chart>
      </div>
      <div class="dashboard-widget">
        <ziro-migrations-donut-chart
          data-automation="usage-type-chart"
          [isRefreshing]="isReportDataRefreshing()"
          [isError]="isReportWidgetError"
          [data]="usageTypeData"
          [label]="'tkey;migrations.number_report.dashboard.usage_type.label'"
          [labelTooltip]="'tkey;migrations.ring_central.number_report.dashboard.usage_type.label.tooltip'"
          [colorScheme]="colorScheme"
          [customColors]="usageTypeCustomColors"
          [segmentTooltipKeyword]="'tkey;migrations.number_report.dashboard.numbers.label'"
          [totalSubtext]="'tkey;migrations.number_report.dashboard.total_numbers.label'"
          [legendCountLabelSingular]="'tkey;migrations.number_report.dashboard.numbers.label.singular'"
          [legendCountLabelPlural]="'tkey;migrations.number_report.dashboard.numbers.label.plural'"
          (dataClick)="onNumbersReportFilter($event, 'lineType')"
          (errorButtonClick)="onRefreshClick()"
        ></ziro-migrations-donut-chart>
      </div>
      <div class="dashboard-widget">
        <ziro-migrations-donut-chart
          data-automation="device-type-chart"
          [isRefreshing]="isReportDataRefreshing()"
          [isError]="isReportWidgetError"
          [data]="deviceTypeData"
          [label]="'tkey;migrations.number_report.dashboard.device_type.label'"
          [labelTooltip]="'tkey;migrations.ring_central.number_report.dashboard.device_type.label.tooltip'"
          [colorScheme]="colorScheme"
          [customColors]="deviceTypeCustomColors"
          [segmentTooltipKeyword]="''"
          [totalSubtext]="'tkey;migrations.number_report.dashboard.total_numbers.label'"
          [legendCountLabelSingular]="'tkey;migrations.number_report.dashboard.numbers.label.singular'"
          [legendCountLabelPlural]="'tkey;migrations.number_report.dashboard.numbers.label.plural'"
          (dataClick)="onNumbersReportFilter($event, 'deviceType')"
          (errorButtonClick)="onRefreshClick()"
        ></ziro-migrations-donut-chart>
      </div>
      <div class="dashboard-widget">
        <ziro-migrations-donut-chart
          data-automation="call-queue-chart"
          [isRefreshing]="isCallQueueRefreshing()"
          [isError]="isCallQueueError"
          [data]="callQueueData"
          [label]="'tkey;migrations.ring_central.dashboard.call_queue.label'"
          [labelTooltip]="'tkey;migrations.ring_central.dashboard.call_queue.label.tooltip'"
          [colorScheme]="colorScheme"
          [isDisabled]="!isCallQueueRefreshing() && !isCallQueueError && callQueueData.length === 0"
          [disabledText]="callQueueDisabledText"
          [segmentTooltipKeyword]="'tkey;migrations.ring_central.dashboard.call_queues.label'"
          [totalSubtext]="'tkey;migrations.ring_central.dashboard.call_queues.total.label'"
          [legendCountLabelSingular]="'tkey;migrations.ring_central.dashboard.call_queue.label.singular'"
          [legendCountLabelPlural]="'tkey;migrations.ring_central.dashboard.call_queues.label'"
          (dataClick)="onCallQueueChartClick()"
          (errorButtonClick)="onRefreshClick()"
        ></ziro-migrations-donut-chart>
      </div>
      <div class="dashboard-widget">
        <ziro-migrations-text-card
          data-automation="auto-attendant-card"
          [isRefreshing]="isAutoAttendantRefreshing()"
          [isError]="isAutoAttendantError"
          [data]="autoAttendantData"
          [label]="'tkey;migrations.ring_central.dashboard.auto_attendant.label'"
          [labelTooltip]="'tkey;migrations.ring_central.dashboard.auto_attendant.label.tooltip'"
          [isDisabled]="!isAutoAttendantRefreshing() && !isAutoAttendantError && autoAttendantData.length === 0"
          [disabledText]="autoAttendantDisabledText"
          (dataClick)="onAutoAttendantChartClick()"
          (errorButtonClick)="onRefreshClick()"
        ></ziro-migrations-text-card>
      </div>
    </div>
  }
</div>
